<div class="flex flex-wrap justify-content-between align-content-center">
  <div
    class="text-center mr-1 border-round overview-detail flex-grow-1"
    *ngFor="let item of items"
  >
    <label
      [for]="item.value"
      [class]="
        settings.style == 'button'
          ? 'p-button p-button-rounded text-center mr-1 my-1 ' +
            (item?.chipClass
              ? item.chipClass + '-chip p-chip'
              : 'Placed-chip chip')
          : 'mr-1 my-1'
      "
      [ngClass]="item.selected ? 'p-button-outlined' : 'no-background'"
    >
      <input
        [class]="settings.style == 'button' ? 'no-box' : ''"
        [id]="item.value"
        type="checkbox"
        [value]="item.value"
        [(ngModel)]="item.selected"
        (change)="updateCheckBoxes()"
      />
      <i
        *ngIf="settings.style == 'button'"
        class="mr-1"
        [ngClass]="item.selected ? 'pi pi-check' : 'pi pi-times'"
      ></i>
      {{ item.label }}
    </label>
  </div>
</div>

<!-- TODO INCORPORATE A DROP DOWN WHEN MOBILE -->
